import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import {applianceThumbnail} from "../assets";

import Dishwasher from "../subparts/appliances/dishwasher";
import Fridge from "../subparts/appliances/fridge";
import Hood from "../subparts/appliances/hood";
import Microwave from "../subparts/appliances/microwave";
import Range from "../subparts/appliances/range";
import Oven from "../subparts/appliances/oven";
import Stove from "../subparts/appliances/stove";
import FridgeEnclosure from "../subparts/appliances/fridgeEnclosure";
import FridgeEnclosureHandle from "../subparts/appliances/fridgeEnclosureHandle";
import Stovetop from "../subparts/appliances/stovetop";

export default class Appliance extends Part {
  static id = 'Appliances';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Appliances';
    this.partThumbnail = applianceThumbnail;
    this.partThumbnailSize = "70%";
    this.translateId = "visualizer.kitchen.appliance";

    // related items
    this.dishwasher = null;
    this.fridge = null;
    this.hood = null;
    this.microwave = null;
    this.range = null;
    this.stove = null;
    this.stovetop = null;
    this.fridgeEnclosure = null;
    this.fridgeEnclosureHandle = null;
    this.oven = null;
    this.relatedGroupNames = ["Dishwasher", "Fridge", "Fridge Enclosure", "Hood", "Microwave", "Range", "Stove",
      "Stovetop", "Oven"];
  }

  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Dishwasher":
        relatedItemName = "dishwasher";
        RelatedItemClass = Dishwasher;
        break;
      case "Fridge":
        relatedItemName = "fridge";
        RelatedItemClass = Fridge;
        break;
      case "Fridge Enclosure Handle":
        relatedItemName = "fridgeEnclosureHandle";
        RelatedItemClass = FridgeEnclosureHandle;
        break;
      case "Fridge Enclosure":
        relatedItemName = "fridgeEnclosure";
        RelatedItemClass = FridgeEnclosure;
        break;
      case "Hood":
        relatedItemName = "hood";
        RelatedItemClass = Hood;
        break;
      case "Microwave":
        relatedItemName = "microwave";
        RelatedItemClass = Microwave;
        break;
      case "Range":
        relatedItemName = "range";
        RelatedItemClass = Range;
        break;
      case "Stove":
        relatedItemName = "stove";
        RelatedItemClass = Stove;
        break;
      case "StoveTop":
      case "Stovetop":
        relatedItemName = "stovetop";
        RelatedItemClass = Stovetop;
        break;
      case "Oven":
        relatedItemName = "oven";
        RelatedItemClass = Oven;
        break;
    }
    return this.loadCommon(relatedItemName, RelatedItemClass, dbFeature, loadFeature)
  }

  isSubTypeWithItems() {
    return false;
  }

  handleSubPartClick() {

  }

}
